import React from 'react';
import {useHistory} from 'react-router-dom';
import {Button, Grid, Typography, Container, useTheme, useMediaQuery} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const NotFoundPage = () => {
	const history = useHistory(); // Updated from useHistory
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Container maxWidth="lg" sx={{height: '100vh'}}>
			<Grid
				container
				spacing={isMobile ? 2 : 3}
				direction="column"
				alignItems="center"
				justifyContent="center"
				sx={{
					minHeight: '100%',
					px: {xs: 2, sm: 3, md: 4},
					py: {xs: 4, sm: 6, md: 8},
				}}
			>
				{/* 404 Number */}
				<Grid item>
					<Typography
						variant="h1"
						component="h1"
						sx={{
							fontSize: {xs: '4rem', sm: '6rem', md: '8rem'},
							fontWeight: 'bold',
							mb: {xs: 2, sm: 3},
						}}
					>
						404
					</Typography>
				</Grid>

				{/* Main Error Message */}
				<Grid item>
					<Typography
						variant="h4"
						component="h2"
						sx={{
							fontSize: {xs: '1.5rem', sm: '2rem', md: '2.5rem'},
							mb: {xs: 2, sm: 3},
						}}
					>
						Sidan hittades inte
					</Typography>
				</Grid>

				{/* Error Description */}
				<Grid item sx={{width: '100%', maxWidth: 'sm'}}>
					<Typography
						variant="body1"
						sx={{
							textAlign: 'center',
							mb: 2,
							fontSize: {xs: '1rem', sm: '1.1rem'},
						}}
					>
						Det gick inte att hitta någon sida som matchade URL:en:
					</Typography>
					<Typography
						variant="h6"
						sx={{
							wordBreak: 'break-all',
							textAlign: 'center',
							fontSize: {xs: '0.9rem', sm: '1rem', md: '1.25rem'},
							bgcolor: 'rgba(0, 0, 0, 0.04)',
							p: 2,
							borderRadius: 1,
						}}
					>
						{window.location.host}
						{window.location.pathname}
					</Typography>
				</Grid>

				{/* Button */}
				<Grid item sx={{mt: {xs: 3, sm: 4, md: 5}}}>
					<Button
						variant="contained"
						color="primary"
						size={isMobile ? 'medium' : 'large'}
						onClick={() => history.goBack()}
						sx={{
							bgcolor: '#4cae52',
							'&:hover': {
								bgcolor: '#3d8b42',
							},
							transition: 'all .2s ease-in-out',
							textTransform: 'none',
							fontFamily: 'Titillium Web',
							px: {xs: 3, sm: 4},
							py: {xs: 1, sm: 1.5},
						}}
						startIcon={<ArrowBackIcon />}
					>
						Gå tillbaka
					</Button>
				</Grid>
			</Grid>
		</Container>
	);
};

export default NotFoundPage;
